import React from 'react';

import type { InputGroup } from '../../lib/input-group.jsx';
import type { Input } from '../../lib/input.jsx';

type AutocompleteContextValue<TData = unknown> = {
  popoverOpen: boolean;
  setPopoverOpen: React.Dispatch<React.SetStateAction<boolean>>;
  onAutocompleteOpen: () => void;
  inputRef: React.RefObject<HTMLInputElement | null>;

  autocompleteValue: string;
  setAutocompleteValue: React.Dispatch<React.SetStateAction<string>>;
  formatAutocompleteValue: (value: string) => string;

  selectedIndex: number;
  setSelectedIndex: React.Dispatch<React.SetStateAction<number>>;

  options: TData[];
  onClear: () => void;
  clearable: boolean;
  autoFocus: boolean;

  disabled: React.ComponentProps<typeof Input>['disabled'];
  size: React.ComponentProps<typeof InputGroup>['size'];
  color: React.ComponentProps<typeof InputGroup>['color'];
  helperText: string;

  getOptionLabel: (option: TData) => string;
  isSelectedOption: (option: TData) => boolean;
  onAutocompleteChange: (option: TData) => void;
  isLoadingOptions: boolean;
};

export const AutocompleteContext =
  React.createContext<AutocompleteContextValue | null>(null);

export function useAutocompleteContext<TData>() {
  const ctx = React.useContext(AutocompleteContext);
  if (!ctx) {
    throw new Error(
      'Autocomplete components must be used within <Autocomplete />',
    );
  }
  return ctx as AutocompleteContextValue<TData>;
}
